export default __webpack_public_path__ + "static/media/uploadtcno-white.d3d34b86.svg";